import { render, staticRenderFns } from "./Navi.vue?vue&type=template&id=5747ddbc"
import script from "./Navi.vue?vue&type=script&lang=js"
export * from "./Navi.vue?vue&type=script&lang=js"
import style0 from "./Navi.vue?vue&type=style&index=0&id=5747ddbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports